export type BillingEvent = 'LEMBRETE' | 'COBRANÇA' | 'REVISTORIA' | 'REATIVAÇÃO' | 'RECUPERAÇÃO' | 'SEM EVENTOS';

export type BillingMonth = 'atual' | '-1' | '-2' | '+1';

export type DateMode = 'fixed' | 'period_due' | 'period_overdue';

export type PeriodDueMode = 'range' | 'days_back';

export type ExecutionMode = 'fixed_day' | 'frequency';

export interface BillingRule {
  id: number;
  client_id: number;
  day: number;
  event: BillingEvent;
  due_day: number;
  billing_month: BillingMonth;
  window_start?: string;
  days_before_due?: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  date_mode?: DateMode;
  due_day_inicio?: number;
  due_day_fim?: number;
  period_due_mode?: PeriodDueMode;
  dias_para_tras?: number;
  incluir_dia_atual?: boolean;
  dias_vencidos_inicio?: number;
  dias_vencidos_fim?: number;
  execution_mode?: ExecutionMode;
  frequencia_intervalo?: number;
  frequencia_dia_inicio?: number;
}

export interface NewBillingRule {
  day?: number;
  event: BillingEvent;
  due_day?: number;
  billing_month?: BillingMonth;
  days_before_due?: number;
  date_mode?: DateMode;
  due_day_inicio?: number;
  due_day_fim?: number;
  period_due_mode?: PeriodDueMode;
  dias_para_tras?: number;
  incluir_dia_atual?: boolean;
  dias_vencidos_inicio?: number;
  dias_vencidos_fim?: number;
  execution_mode?: ExecutionMode;
  frequencia_intervalo?: number;
  frequencia_dia_inicio?: number;
}

export interface BillingRuleFormData {
  day: string;
  event: BillingEvent;
  due_day: string;
  billing_month: BillingMonth;
  days_before_due?: string;
  date_mode?: DateMode;
  due_day_inicio?: string;
  due_day_fim?: string;
  period_due_mode?: PeriodDueMode;
  dias_para_tras?: string;
  incluir_dia_atual?: boolean;
  dias_vencidos_inicio?: string;
  dias_vencidos_fim?: string;
  execution_mode?: ExecutionMode;
  frequencia_intervalo?: string;
  frequencia_dia_inicio?: string;
}

export const EXECUTION_MODES: { value: ExecutionMode; label: string }[] = [
  { value: 'fixed_day', label: 'Dia fixo' },
  { value: 'frequency', label: 'Frequência (X em X dias)' }
];

export const BILLING_EVENTS: BillingEvent[] = [
  'LEMBRETE',
  'COBRANÇA', 
  'REVISTORIA', 
  'REATIVAÇÃO', 
  'RECUPERAÇÃO', 
  'SEM EVENTOS'
];

export const DATE_MODES: { value: DateMode; label: string }[] = [
  { value: 'fixed', label: 'Data fixa' },
  { value: 'period_due', label: 'Período por vencimento' },
  { value: 'period_overdue', label: 'Período vencidos' }
];

export const PERIOD_DUE_MODES: { value: PeriodDueMode; label: string }[] = [
  { value: 'range', label: 'Faixa fixa (dia inicial - dia final)' },
  { value: 'days_back', label: 'Dias para trás' }
];

export const BILLING_MONTHS: { value: BillingMonth; label: string }[] = [
  { value: 'atual', label: 'Mês Atual' },
  { value: '-1', label: 'Mês Anterior (-1)' },
  { value: '-2', label: '2 Meses Atrás (-2)' },
  { value: '+1', label: 'Próximo Mês (+1)' }
];

export const DAYS = Array.from({ length: 31 }, (_, i) => ({
  value: (i + 1).toString(),
  label: (i + 1).toString()
}));

export type BillingCategory = 'LEMBRETE' | 'COBRANÇA' | 'BOAS-VINDAS' | 'RENOVAÇÃO' | 'ANIVERSÁRIO' | 'PAGAMENTO';

export interface BillingWindowStartConfig {
  window_start_lembrete?: string;
  window_start_cobranca?: string;
  window_start_revistoria?: string;
  window_start_aniversario?: string;
  window_start_pagamento?: string;
  is_active_aniversario?: boolean;
  is_active_pagamento?: boolean;
}

export interface BillingWindowStartResponse {
  success: boolean;
  data?: BillingWindowStartConfig;
  message?: string;
  error?: string;
} 